import { useEffect, useState } from "react";
import { EditFormContextType } from "../../../../contexts/EditFormContext";
import EventManager from "../../../../services/EventManager";
import {  useNavigate } from "react-router-dom";
import { useTranslation } from "../../../../contexts/TranslationProvider";
import '../buttons.scss'

function EditFormSaveButton() {
  const navigate=useNavigate()
  const [editFormContext, setEditFormContext] = useState<EditFormContextType>(null)
  const { t } = useTranslation();
  const handleFormSubmit = async () => {
   EventManager.invoke('SubmitForm', editFormContext)
   EventManager.invoke('SubmitBeneficial', true)
  };
  useEffect(() => {
    EventManager.subscribe('EditFormContext', setEditFormContext)
    return () => {
      EventManager.unsubscribe('EditFormContext', setEditFormContext)
    }
  }, [])

  return (
    <button className="navbar-button" type="submit" onClick={handleFormSubmit}>
      {editFormContext?.completionPercentage !== 100
        ? t("navbar.saveForm1")
        : t("navbar.saveForm2")}
    </button>
  );
}

export default EditFormSaveButton;
